import { useCallback, useEffect } from "react";

import AscButton from "../../../../AscButton/AscButton";
import AscFilesUploader from "../../../../AscFilesUploader/AscFilesUploader";
import AscHeading from "../../../../AscTypography/AscHeading/AscHeading";

import styles from "./AscActivityTrueFalse.module.scss";
import { ActivityImage, TRUE_FALSE_OPTIONS } from "@ascendnow/shared";
import AscSelectActivityQuestionAnswerForm from "../../../AscSelectActivityQuestionAnswerForm/AscSelectActivityQuestionAnswerForm";
import { useAscAddModuleActivitiesForm } from "../../useAscAddModuleActivitiesForm";

export default function AscActivityTrueFalse() {
  const formik = useAscAddModuleActivitiesForm();

  const emptyQuestion = {
    question: "",
    answer: undefined,
  };

  const handleUpload = useCallback(
    (acceptedFiles: ActivityImage[]) => {
      formik.setFieldValue(
        "trueFalse.image",
        acceptedFiles?.slice(
          0,
          formik?.values?.trueFalse?.questions?.questions?.length
        )
      );
    },
    [formik?.values?.trueFalse?.questions?.questions?.length]
  );

  function handleChange(
    index: number,
    question: { question: string; answer?: string }
  ) {
    const newQuestions = [
      ...(formik?.values?.trueFalse?.questions?.questions || []),
    ];

    newQuestions[index] = {
      ...newQuestions[index],
      question: question?.question,
      answer:
        question?.answer === undefined
          ? undefined
          : question?.answer === "true"
          ? true
          : false,
    };
    formik.setFieldValue("trueFalse.questions.questions", newQuestions);
  }

  function handleDelete(index: number) {
    const newQuestions = [
      ...(formik?.values?.trueFalse?.questions?.questions || []),
    ];
    newQuestions.splice(index, 1);
    if (newQuestions.length === 0) {
      newQuestions.push(emptyQuestion);
    }
    formik.setFieldValue("trueFalse.questions.questions", newQuestions);
  }

  function handleAddQuestion() {
    const questions = [
      ...(formik?.values?.trueFalse?.questions?.questions || []),
    ];
    questions.push(emptyQuestion);
    formik.setFieldValue("trueFalse.questions.questions", questions);
  }

  useEffect(() => {
    if (!formik?.values?.trueFalse?.questions?.questions?.length) {
      handleAddQuestion();
    }
  }, []);

  return (
    <div className={styles.ground}>
      <div className={styles.headerGround}>
        <AscHeading className={styles.header} level={6}>
          Questions & Answers
        </AscHeading>

        <AscButton
          className={styles.link}
          variant="link"
          hideLinkIcon={true}
          onClick={handleAddQuestion}
        >
          Add question <span>+</span>
        </AscButton>
      </div>

      {formik?.values?.trueFalse?.questions?.questions.map(
        (question, index: number) => (
          <AscSelectActivityQuestionAnswerForm
            key={index}
            selectOptions={[...TRUE_FALSE_OPTIONS]}
            value={{
              question: question?.question,
              answer:
                question?.answer === undefined
                  ? undefined
                  : question?.answer?.toString(),
            }}
            onChange={(q) => handleChange(index, q)}
            canDelete
            onDelete={() => handleDelete(index)}
          />
        )
      )}

      <div className={styles.dropzoneField}>
        <AscFilesUploader
          name="image"
          type="image"
          accept={{
            "image/*": [".jpeg", ".png"],
          }}
          maxFiles={
            formik?.values?.trueFalse?.questions?.questions?.length || 1
          }
          multiple={true}
          onChange={handleUpload}
          initialValue={
            formik?.values?.trueFalse?.image?.length
              ? formik.values.trueFalse.image?.filter(
                  (f) => !f?.__activityImage || f?.__activityImage?.location
                )
              : []
          }
        />
      </div>
    </div>
  );
}
